import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { apiRequest } from "../helpers/api";
import { getToken, logout, setAuthData } from "../helpers/authHelper";
import { AuthErrorScreen, AuthLoadingScreen } from "./auth/AuthShowcase";

const GuestOnlyRoute = () => {
  const token = getToken();
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(Boolean(token));
  const [authCheckError, setAuthCheckError] = useState("");
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    if (!token) {
      setUser(null);
      setChecking(false);
      return undefined;
    }
    let active = true;
    setAuthCheckError("");
    apiRequest("/api/auth/me")
      .then(({ user: currentUser }) => {
        if (!active) return;
        setAuthData(token, currentUser);
        setUser(currentUser);
      }).catch((requestError) => {
        if (!active) return;
        if ([401, 403].includes(requestError.status)) {
          logout();
          setUser(null);
          return;
        }
        setAuthCheckError(requestError.message || "Unable to verify your session. Check your connection and try again.");
      })
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, [retryCount, token]);

  if (checking) return <AuthLoadingScreen />;
  if (authCheckError) return <AuthErrorScreen message={authCheckError} onRetry={() => { setChecking(true); setRetryCount((count) => count + 1); }} />;
  if (!token || !user) return <Outlet />;
  if (user.role === "admin") return <Navigate to="/admin/dashboard" replace />;
  return <Navigate to={user.onboardingComplete ? "/dashboard" : "/onboarding"} replace />;
};

export default GuestOnlyRoute;
